import React, { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

// Counts up from 0 to `value` on mount with an ease-out curve.
// Respects the user's "reduce motion" OS setting (shows the final value immediately).
const StatCounter = function({ value, suffix = "", duration = 1.4 }) {
  const reduceMotion = useReducedMotion();
  const [display, setDisplay] = useState(reduceMotion ? value : 0);

  useEffect(() => {
    if (reduceMotion) {
      setDisplay(value);
      return;
    }
    let raf;
    let start;
    const step = (ts) => {
      if (start === undefined) start = ts;
      const progress = Math.min((ts - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(eased * value));
      if (progress < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, duration, reduceMotion]);

  return <>{display}{suffix}</>;
}

export default StatCounter;
